import { ComponentProps } from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';

import { cn } from '@/lib/utils';

const Separator = (props: ComponentProps<typeof SeparatorPrimitive.Root>) => {
  const {
    className,
    orientation = 'horizontal',
    decorative = true,
    ...restProps
  } = props;

  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      decorative={decorative}
      orientation={orientation}
      className={cn(
        'bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px',
        className,
      )}
      {...restProps}
    />
  );
};

export { Separator };
